import { useTranslation } from 'react-i18next';
import { ReactComponent as ExclamationTriangle } from '../../../assets/warning-tip.svg';
import { UnverifiedPillContainer } from './unverified-pill.styles';

const UnverifiedPill = () => {
  const { t } = useTranslation();

  return (
    <UnverifiedPillContainer>
      <ExclamationTriangle aria-hidden />
      {t('unverified')}
    </UnverifiedPillContainer>
  );
};

export default UnverifiedPill;
